import { initializeApp, getApps, getApp } from "firebase/app";
import {
    getMessaging,
    getToken,
    onMessage,
    isSupported
} from "firebase/messaging";

const VAPID_KEY = "BCCLvIU9-zzKB1r5yZrQtCW7J18NfGnX59SFKQvxiUEY8Oms64_H8NTxNWjsuKYzBgj6jeU7pkxyq-19mgINZYU"


// -------------------------
// 🔥 Initialize Firebase App
// -------------------------
const firebaseConfig = {
    apiKey: "AIzaSyBIjrPLinO3eHfA9elYbJNNjDG2eAvp1EM",
    authDomain: "parentconnect-4fe39.firebaseapp.com",
    databaseURL: "https://parentconnect-4fe39.firebaseio.com",
    projectId: "parentconnect-4fe39",
    storageBucket: "parentconnect-4fe39.appspot.com",
    messagingSenderId: "78077811192",
    appId: "1:78077811192:web:165e4515cbbc4c0b0f1e0d",
};

// ----------------------------------------
// 1️⃣ Initialize Firebase (singleton)
// ----------------------------------------
const firebaseApp = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// ----------------------------------------
// 2️⃣ MAIN FUNCTION
// ----------------------------------------
export const initializeFirebase = async (onSuccess, onMsg, onError) => {
    try {
        // Check if browser supports FCM
        const supported = await isSupported();
        if (!supported) {
            if (onError) onError("Notifications not supported on this browser.");
            return;
        }

        // Register the service worker FIRST
        const swReg = await navigator.serviceWorker.register(
            "/firebase-messaging-sw.js"
        );
        await navigator.serviceWorker.ready;

        // Firebase messaging instance
        const messaging = getMessaging(firebaseApp);

        // Request permission
        if (!("Notification" in window)) {
            if (onError) onError("Notifications not supported on this browser.");
            return;
        }
        const permission = await Notification.requestPermission();
        if (permission !== "granted") {
            if (onError) onError("Please allow notifications.");
            return;
        }

        // Get FCM token
        const token = await getToken(messaging, {
            vapidKey: VAPID_KEY,
            serviceWorkerRegistration: swReg,
        });

        console.log("Web Token:", token);
        if (onSuccess) onSuccess(token);

        // Foreground notifications
        onMessage(messaging, (payload) => {
            console.log("Message received:", payload);
            if (onMsg && payload?.notification) {
                onMsg(payload.notification);
            }
        });

    } catch (err) {
        console.error("FCM Setup Error:", err);
        if (onError) onError(err.message || "Notification setup failed");
    }
};